import { ViewModel,View } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { ChildAcceptableFormBuilderElement, FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { BooleanPropertyType, ContentPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import  { LoadingView } from "./loading-view"

export class LoadingComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Loading';
        this.canAcceptContent = true;
        this.addProperty("Content","",new ContentPropertyType(this),null,true);
        this.addProperty("IsLoading","data-b-comp-isloading",new BooleanPropertyType(this),false,false);
    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new LoadingViewModel(parent);
        return result;
    }
        
}
export class LoadingViewModel extends ChildAcceptableFormBuilderElement{
    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new LoadingView();
    }
    public getTypeId(): string {
        return "VM-F8DDAC6A-7B5E-4FA7-AD7C-63EED8B978B9"
    }

    public set Content(v: FormBuilderElement) { this._Content = v; } public get Content(): FormBuilderElement { return this._Content;} private _Content: FormBuilderElement;
    public set IsLoading(v: boolean) { this._IsLoading = v; } public get IsLoading(): boolean { return this._IsLoading;} private _IsLoading: boolean;
            
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitLoading(this,parameter);
    }
    addChildInternal(element: FormBuilderElement): void {
        this.children.update(...[element]);
        this.Content = element;
    }
    removeChild(element: FormBuilderElement): void {
        if(element && this.Content &&this.Content.self == element.self){
            this.children.clear();
            this.Content = null;
        }
    }
}
